const config = window.MentorMeConfigurations;
export default config;